import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { rutClean, rutFormat } from 'src/app/utils/rut.directive';
import { ClienteService } from '../cliente.service';

@Component({
  selector: 'app-cliente-create',
  templateUrl: './cliente-create.component.html',
  styleUrls: ['./cliente-create.component.scss']
})
export class ClienteCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: ClienteService,
    public formatter: FormatterService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      nombre: ['', [Validators.required]],
      apellido: ['', [Validators.required]],
      rut: ['', []],
      fono: [null],
      rol_id: [4, [Validators.required]],
    });
  }

  changed_rut(element: any) {
    let htmlInputElement: HTMLInputElement = <HTMLInputElement>element.target;
    htmlInputElement.value = rutFormat(htmlInputElement.value) || '';
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      if(this.form.value.rut) {
        let rut = rutClean(this.form.value.rut);
        this.form.controls['rut'].setValue(rut);
      }
      this.service.insert(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Cliente registrado con éxito.", "success");
          this.alerts.addAlert("Se ha enviado un correo electrónico al cliente con los pasos para configurar su cuenta.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de cliente.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }
}